import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import LazyLoad from 'react-lazyload';
import { IImage } from '../../../../utils/types/contentful';
import { handleReturnWithLazy } from '../../../../utils/globals';

export const Image = ({
  height,
  altText,
  isNative,
  loading,
  media,
  objectFit,
  objectPlacement,
  placeholder,
  width,
  bgColor,
  className,
}: IImage) => {
  let image = getImage(media);

  // GATSBY IMAGE
  if (image && !isNative) {
    image = { ...image, backgroundColor: bgColor || '' };

    return handleReturnWithLazy(
      <GatsbyImage
        alt={altText}
        height={height}
        imgStyle={{ width, height, objectFit }}
        image={image}
        loading={loading}
        style={{ width, height }}
        width={width}
        backgroundColor={bgColor}
        placeholder={placeholder}
        grayscale={true}
        className={`object-${objectFit} object-${objectPlacement} ${className}`}
      />,
      loading === 'lazy'
    );
  } else {
    // NATIVE IMAGE
    if (media?.file) {
      return handleReturnWithLazy(
        <img
          alt={altText}
          height={height}
          src={media.file.url}
          loading={loading}
          style={{ width, height }}
          width={width}
          className={`object-${objectFit} object-${objectPlacement}`}
        />,
        loading === 'lazy'
      );
    }
    return <></>;
  }
};
